export default __webpack_public_path__ + "static/media/spaceXhub2.c3119a0d.png";